<h1 mat-dialog-title>ASSEGNA CODICE PROFILO PROFESSIONALE<mat-icon class="close-icon" (click)="onClose()">close</mat-icon></h1>

<div mat-dialog-content>
  <div class="d-flex">
    <mat-form-field style="margin-top:20px; margin-right: auto; margin-left: auto">
      <mat-label>Codice profilo professionale*</mat-label>
      <input matInput type="text" pattern="^\d+(\.\d{1,3})?$" [(ngModel)]="data.code">
    </mat-form-field>
  </div>

</div>

<div mat-dialog-actions class="actions mt-15">

  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onClose()">
    <mat-icon>close</mat-icon>
    Annulla
  </button>

  <button mat-fab extended class="searchbox-buttons save-button" (click)="handleAssignment()">
    <mat-icon>compare_arrows</mat-icon>
    Assegna
  </button>
</div>
